import { queryOptions, useQuery } from "@tanstack/react-query";
import { type Region, getLicensesTypes } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const LICENSE_QUERY_KEY = "LICENSE";

export const getLicenseQueryKey = (region?: Region) => [
  LICENSE_QUERY_KEY,
  region,
];

export const licenseQueryOptions = (region?: Region) =>
  queryOptions({
    queryKey: getLicenseQueryKey(region),
    queryFn: processResponseWithApiProblemDetails(() =>
      getLicensesTypes(region),
    ),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 1,
  });

export const useLicenseQuery = (region?: Region) =>
  useQuery({
    ...licenseQueryOptions(region),
    enabled: !!region,
  });
